import * as React from "react";

import {
  FeatureController,
  FeaturesProvider,
  OneTimePasswordFeatures,
  useOneTimePasswordFeatureController,
} from "../../../Common";

import { useReactMyBagInitialState } from "../react-my-bag-initial-state-provider";

export const ReactMyBagFeatures = OneTimePasswordFeatures;

export const ReactMyBagFeaturesProvider: React.FunctionComponent = (props) => {
  const { initialState } = useReactMyBagInitialState();

  const oneTimePasswordFeatureController = useOneTimePasswordFeatureController({
    initialState,
  });

  const features: FeatureController[] = React.useMemo(
    () => [oneTimePasswordFeatureController],
    [oneTimePasswordFeatureController]
  );

  return (
    <FeaturesProvider features={features}>
      {props.children || []}
    </FeaturesProvider>
  );
};
